var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9502C11.8667 14.9502 11.7417 14.9292 11.625 14.8872C11.5083 14.8459 11.4 14.7752 11.3 14.6752L6.675 10.0502C6.49167 9.86689 6.40433 9.63755 6.413 9.36222C6.421 9.08755 6.51667 8.85855 6.7 8.67522C6.88333 8.49189 7.11667 8.40022 7.4 8.40022C7.68333 8.40022 7.91667 8.49189 8.1 8.67522L12 12.5752L15.925 8.65022C16.1083 8.46689 16.3377 8.37922 16.613 8.38722C16.8877 8.39589 17.1167 8.49189 17.3 8.67522C17.4833 8.85855 17.575 9.09189 17.575 9.37522C17.575 9.65855 17.4833 9.89189 17.3 10.0752L12.7 14.6752C12.6 14.7752 12.4917 14.8459 12.375 14.8872C12.2583 14.9292 12.1333 14.9502 12 14.9502Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow_bottom.9dc7915e209ec8cfd394e4f2794abecd.svg";
export { ForwardRef as ReactComponent };